export const ADD_ROW = 'DataTable/ADD_ROW';
export const ADD_ROW_CANCEL = 'DataTable/ADD_ROW_CANCEL';
export const ADD_ROW_SAVE = 'DataTable/ADD_ROW_SAVE';

export const EDIT_ROW = 'DataTable/EDIT_ROW';
export const EDIT_ROW_CANCEL = 'DataTable/EDIT_ROW_CANCEL';
export const EDIT_ROW_SAVE = 'DataTable/EDIT_ROW_SAVE';

export const INIT_TABLE = 'DataTable/INIT_TABLE';
export const CLEAR_TABLE = 'DataTable/CLEAR_TABLE';

export const UPDATE_STORE = 'DataTable/UPDATE_STORE';



// WEBPACK FOOTER //
// ./src/hardware/VuexTable/constants.js